<template>
  <div class="aliexpress-info">
    <validation-component
      ref="aliexpressForm"
      :validation-condition="aliexpressCondition"
    >
    </validation-component>
  </div>
</template>

<script>
import { REQUIRED } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import { checkCharLength } from '@/utils/tools/utils';

export default {
  components: {
    ValidationComponent,
  },
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      aliexpressCondition: [{
        key: 'appName',
        name: 'message.application.merchantName',
        type: 'input',
        defValue: '',
        isShowStar: true,
        placeholder: this.$t('message.validator.input', { select: '' }),
        rule: [REQUIRED],
        maxLength: 64,
        validator: this.validateAppName,
      }, {
        key: 'accountNo',
        name: 'message.application.aliExpressAccount',
        type: 'input',
        defValue: '',
        isShowStar: true,
        placeholder: this.$t('message.validator.input', { select: '' }),
        rule: [REQUIRED],
      }, {
        key: 'registerSubjectName',
        name: 'message.application.aliExpressEntityName',
        type: 'input',
        defValue: '',
        isShowStar: true,
        placeholder: this.$t('message.validator.input', { select: '' }),
        rule: [REQUIRED],
      }, {
        key: 'storeUrl',
        name: 'message.application.aliExpressMerchantUrl',
        type: 'input',
        defValue: '',
        isShowStar: true,
        placeholder: this.$t('message.validator.input', { select: '' }),
        rule: [REQUIRED],
      }],
    };
  },
  mounted() {
    this.initMehtod();
  },
  methods: {
    initMehtod() {
      this.$refs.aliexpressForm.assignmentFormValue(this.info);
    },
    validateAppName(rule, value, callback) {
      if (value && !checkCharLength(value, 64)) {
        callback(new Error(this.$t('message.application.appNameErrorTips')));
      }
      callback();
    },
    async getParams() {
      return new Promise((resolve, reject) => {
        this.$refs.aliexpressForm.toFormValid((params) => {
          resolve(params);
        }, (err) => {
          reject(err);
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.aliexpress-info {
  margin-bottom: -20px;

  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
}
</style>
